import { useEffect, useState } from "react";
import { app } from "src/core/app";
import { useTranslation } from "src/i18n";
import { useBreakpoint } from "src/util/cssUtil";
import { BackButton } from ".";

export interface BreadcrumbItem {
    label: string;
    href: string;
}

export interface BreadcrumbProps {
    currentTitle: string;
    items?: BreadcrumbItem[];
}

export function Breadcrumb(props: BreadcrumbProps) {
    const { isMobile } = useBreakpoint();
    const { t } = useTranslation('common');
    const [parentItems, setParentItems] = useState(() => app.navigation.getParentViews());
    const items = [...parentItems, ...(props.items || [])];

    useEffect(() => {
        return app.on('pageload', () => {
            setParentItems(app.navigation.getParentViews());
        });
    }, []);

    if (isMobile) {
        const last = items.slice(-1)[0];
        return items.length ? <BackButton label={t('header.back', last.label)} href={last.href} /> : null;
    }
    return (
        <div className="eac-breadcrumb">
            {items.flatMap((v, i) => [
                !!i && <span key={`sep${i}`} className="eac-breadcrumb-item sep">/</span>,
                <a key={i} className="eac-breadcrumb-item link" href={v.href}>{v.label}</a>
            ])}
            <span className="eac-breadcrumb-item sep">/</span>
            <span className="eac-breadcrumb-item last">{props.currentTitle}</span>
        </div>
    );
}
